export default __webpack_public_path__ + "static/media/2B2009F9-F3D6-4CAC-BE20-A0B2C6DEC2B4.3e523586.jpg";